import rehypeKatex from "rehype-katex";
export const safeRehypeKatex = (options = {}) => {
    return (tree, file) => {
        try {
            const katexProcessor = rehypeKatex(options);
            // Note: Type incompatibility exists between react-markdown@8.0.7 (uses vfile@5.3.7) and
            // rehype-katex@7.0.1 (uses vfile@6.0.3). Consider upgrading to react-markdown@10+ for proper
            // type compatibility.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return katexProcessor(tree, file);
        }
        catch (error) {
            // Log the error for debugging but don't throw.
            console.warn("rehypeKatex processing error:", error);
            // Return the tree unchanged
            return tree;
        }
    };
};
//# sourceMappingURL=safeRehypeKatex.js.map